'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn$002dResult from "./app.pages.-Documents-Create-Page$-Based-On-Result.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate(form) {
  this.Yh = null;
  this.Yh = form;
}
export { $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate as $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate };
$p = $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate.prototype = new $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn$002dResult.$h_Lapp_pages_DocumentsCreatePage$BasedOnResult();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate() {
}
export { $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate as $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate };
$h_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate)) {
    var x = this.Yh;
    var x$2 = x$0.Yh;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "DocumentTemplate";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yh;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "form";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 3;
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kp)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate as $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate };
var $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate, "app.pages.DocumentsCreatePage$BasedOnResult$DocumentTemplate", ({
  kp: 1,
  eD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate as $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$DocumentTemplate };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Based-On-Result$-Document-Template.js.map
